import {usePrescribedNameContext} from '@/shared/contexts/prescribed-name'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {DrugTag} from '@/shared/components/ui/tags/drug-tag'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {prescribedName} = usePrescribedNameContext()

  const items = useMemo(() => {
    return [
      {label: t('id'), value: prescribedName.id},
      {label: t('name'), value: prescribedName.name},
      {
        label: t('active_substance'),
        value: prescribedName.drugCatalogItem ? <DrugTag drug={prescribedName.drugCatalogItem} /> : null,
      },
    ]
  }, [t, prescribedName])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DataSection label={t('properties')}>
        <DataList items={items} />
      </DataSection>
    </Tabs.Content>
  )
}
